// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Leetcode Wizard
 * Leetcode Wizard API Description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PromptRequestDto
 */
export interface PromptRequestDto {
    /**
     *
     * @type {string}
     * @memberof PromptRequestDto
     */
    modelId: string;
    /**
     *
     * @type {string}
     * @memberof PromptRequestDto
     */
    rawPrompt: string;
    /**
     *
     * @type {object}
     * @memberof PromptRequestDto
     */
    variables: object;
    /**
     *
     * @type {Array<string>}
     * @memberof PromptRequestDto
     */
    screenCaptures?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof PromptRequestDto
     */
    responseFormat?: string;
    /**
     *
     * @type {string}
     * @memberof PromptRequestDto
     */
    promptId: string;
    /**
     *
     * @type {string}
     * @memberof PromptRequestDto
     */
    reasoningEffort?: string;
}

/**
 * Check if a given object implements the PromptRequestDto interface.
 */
export function instanceOfPromptRequestDto(value: object): value is PromptRequestDto {
    if (!('modelId' in value) || value['modelId'] === undefined) return false;
    if (!('rawPrompt' in value) || value['rawPrompt'] === undefined) return false;
    if (!('variables' in value) || value['variables'] === undefined) return false;
    if (!('promptId' in value) || value['promptId'] === undefined) return false;
    return true;
}

export function PromptRequestDtoFromJSON(json: any): PromptRequestDto {
    return PromptRequestDtoFromJSONTyped(json, false);
}

export function PromptRequestDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PromptRequestDto {
    if (json == null) {
        return json;
    }
    return {
        modelId: json['modelId'],
        rawPrompt: json['rawPrompt'],
        variables: json['variables'],
        screenCaptures: json['screenCaptures'] == null ? undefined : json['screenCaptures'],
        responseFormat: json['responseFormat'] == null ? undefined : json['responseFormat'],
        promptId: json['promptId'],
        reasoningEffort: json['reasoningEffort'] == null ? undefined : json['reasoningEffort'],
    };
}

export function PromptRequestDtoToJSON(value?: PromptRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        modelId: value['modelId'],
        rawPrompt: value['rawPrompt'],
        variables: value['variables'],
        screenCaptures: value['screenCaptures'],
        responseFormat: value['responseFormat'],
        promptId: value['promptId'],
        reasoningEffort: value['reasoningEffort'],
    };
}
